/* eslint-disable react/prop-types */
import React from 'react';

import AmChart from './amchart.jsx';

import 'amcharts3/amcharts/serial';
import reportErrors from 'components/charts/reportErrors.jsx';

function getColor(colors, index, random) {
  return random ?
    index === 0 ? colors[index] : colors[Math.floor(Math.random() * (colors.length - 1 - 1)) + 1] :
    colors[index % colors.length];
}

let BarChart = ({
  axisColor,
  axisThickness,
  balloonText,
  bulletBorderThickness,
  colors = ['#52b9e9', '#7b8791', '#006fba', '#043673'],
  columnWidth,
  containerHeight,
  customLabelColor,
  data,
  fillAlphas,
  fillColorsField = 'color',
  fixedColumnWidth = undefined,
  gridAlpha,
  gridThickness,
  inside,
  labelRotation,
  labelText,
  labelsEnabled,
  lineAlpha,
  lineThickness,
  listeners = undefined,
  maximum,
  newCategoryLabel,
  precision = -1,
  randomColors,
  rotate,
  showBalloon,
  tickLength,
  titleField = 'name',
  titleFontSize,
  valueField = 'value',
  verticalAxisTitle = '',
}) =>
  <AmChart height={containerHeight !== null && containerHeight !== undefined ? containerHeight : 300} config={{
    categoryField: titleField,
    dataProvider: data.map((d, i) => Object.assign({}, d, {color: getColor(colors, i, randomColors)})),
    rotate: rotate !== null && rotate !== undefined ? rotate : false,
    theme: 'light',
    type: 'serial',
    zoomOutButtonImage: '',
    graphs: [
      {
        balloonText: balloonText !== null && balloonText !== undefined ? balloonText : '[[value]]',
        bulletBorderThickness: bulletBorderThickness !== null && bulletBorderThickness !== undefined ? bulletBorderThickness : 0,
        columnWidth: columnWidth !== null && columnWidth !== undefined ? columnWidth : undefined,
        fillAlphas: fillAlphas !== null && fillAlphas !== undefined ? fillAlphas : 1,
        fillColorsField: fillColorsField,
        labelText: labelText !== null && labelText !== undefined ? labelText : '',
        lineColorField: 'color',
        colorField: 'color',
        lineAlpha: lineAlpha !== null && lineAlpha !== undefined ? lineAlpha : 0,
        lineThickness: lineThickness !== null && lineThickness !== undefined ? lineThickness : 0,
        type: 'column',
        valueField: valueField,
        fixedColumnWidth: fixedColumnWidth,
        showBalloon: showBalloon !== null && showBalloon !== undefined ? showBalloon : true,
      },
    ],
    categoryAxis: {
      axisThickness: axisThickness !== null && axisThickness !== undefined ? axisThickness : 1,
      axisColor: axisColor !== null && axisColor !== undefined ? axisColor : '#7B8791',
      gridAlpha: 0,
      gridPosition: 'start',
      gridThickness: gridThickness !== null && gridThickness !== undefined ? gridThickness : 1,
      labelColorField: 'labelColor',
      labelFunction: label => newCategoryLabel !== null && newCategoryLabel !== undefined ? newCategoryLabel : label,
      labelRotation: labelRotation !== null && labelRotation !== undefined ? labelRotation : 30,
      tickLength: tickLength !== null && tickLength !== undefined ? tickLength : 5,
      titleFontSize: titleFontSize !== null && titleFontSize !== undefined ? titleFontSize : 13,
    },
    chartCursor: {
      categoryBalloonEnabled: false,
      cursorAlpha: 0,
      zoomable: false,
    },
    valueAxes: [
      {
        maximum,
        axisAlpha: 0,
        gridAlpha: gridAlpha !== null && gridAlpha !== undefined ? gridAlpha : 0.08,
        labelsEnabled: labelsEnabled !== null && labelsEnabled !== undefined ? labelsEnabled : true,
        position: 'left',
        title: verticalAxisTitle,
        minimum: 0,
      },
    ],
    startDuration: 0,
    listeners: listeners,
    numberFormatter: {
      decimalSeparator: '.',
      precision: precision,
      thousandsSeparator: ',',
    },
  }} />;

export default reportErrors(BarChart);
